import { t } from '@framework/i18n/intl/i18next.ts';
import { resolveCustomLabel } from '../utils/resolveCustomLabel.ts';

/**
 * Hook per risolvere le label dei pulsanti del modale di selezione avanzata, con supporto a custom label e i18n
 */
export function useAdvancedSelectModalLabels(params: {
  buttonText?: string;
  cancelButtonText?: string;
}) {
  const { buttonText, cancelButtonText } = params;

  const confirmText = resolveCustomLabel(
    buttonText,
    t('widgets.advanced-select.confirm-button-text', 'Conferma'),
  );

  const cancelText = t(
    'widgets.advanced-select.cancel-changes-button',
    'Annulla',
  );

  const clearSelectionText = resolveCustomLabel(
    cancelButtonText,
    t('widgets.advanced-select.delete-selection', 'Cancella'),
  );

  return {
    confirmText,
    cancelText,
    clearSelectionText,
  };
}
